import api from 'utils/api';
import { decamelizeKeys } from 'humps';

export default function buildActions(apiPrefix) {
  return {
    fetchInsuranceRejections() {
      return api.get(`${apiPrefix}/insurance_rejections`).then(response => response.data);
    },

    removePayerRejection(id) {
      return api.delete(`${apiPrefix}/payer_rejections/${id}`);
    },

    createPayerRejection(formValues) {
      return api.post(`${apiPrefix}/payer_rejections`, decamelizeKeys(formValues));
    },

    removePlanRejection(id) {
      return api.delete(`${apiPrefix}/plan_rejections/${id}`);
    },

    createPlanRejection(formValues) {
      return api.post(`${apiPrefix}/plan_rejections`, decamelizeKeys(formValues));
    },
  };
}
